import React, {useEffect, useState} from "react";
import {AuthService} from './../../services';
import { applyUserPerfCookiesFromAuthUser } from "../../shared/manageTablePersistence";
import { APP_VERSION_NOTE } from "../../shared";
import { EventsService } from "../../services";
import { useNavigate } from "react-router-dom";

const Login = ({ setMenu}) => {

  const getLogoSuffix = () => {
    return (window.location.hostname.includes('worldshine2.mayo.llc') || window.location.hostname.includes('site2') || window.location.host.includes('ws2') ||window.location.hostname.includes('localhost')) ? "Care LLC" : ((window.location.hostname.includes('worldshine3.mayo.llc') ||window.location.hostname.includes('site3') || window.location.hostname.includes('ws3')) ? "Cloverleaf LLC" : "International LLC");
  }
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isSigningIn, setIsSigningIn] = useState(false);
  const navigate = useNavigate();
  const getPostLoginPath = () => {
    if (AuthService.canAccessLegacySystem()) {
      return '/landing';
    }
    if (AuthService.canViewDashboard()) {
      return '/dashboard/dashboard';
    }
    return '/home-empty';
  };
  useEffect(() => {
    if (localStorage.getItem('user') && localStorage.getItem('token')) {
      navigate(getPostLoginPath());
    }
  }, []);
  const loginAndRedirect = () => {
    if (isSigningIn) return;
    setIsSigningIn(true);
    AuthService.login({
      emailUsername: username,
      password,
      site: EventsService.site
    }).then(({data}) => {
      localStorage.setItem('token', data.accessToken);
      localStorage.setItem('user', JSON.stringify(data));
      applyUserPerfCookiesFromAuthUser(data);
      navigate(getPostLoginPath());
      setMenu();
    }).catch((error) => {
      const msg =
        error?.response?.data?.message ||
        error?.message ||
        'Sign in failed. Check your connection and try again.';
      window.alert(msg);
      console.log(error);
    }).finally(() => {
      setIsSigningIn(false);
    });
  };
  return (
    <div className="container container-fixed">
      <div className="login">
        <div className="logo-container"><img class="login-logo" src="/images/logo-trans.png" /><strong className="logo-worldshine">Worldshine</strong><span className="logo-suffix">{getLogoSuffix()}</span></div>
        <div className="login-container mt-4">
          <div className="login-items">
            <div>
              <h6>Sign In</h6>
            </div>
            <div className="mb-2">
              <label for="username">Email/Username</label>
            </div>
            <div className="mb-2">
              <input id="username" name="username" type="text" placeholder="e.g. example@worldshine.com" value={username} onChange={(e) => setUsername(e.currentTarget.value)}></input>
            </div>
            <div className="mb-2">
              <label for="password">Password</label>
            </div>
            <div className="mb-2">
              <input id="password" name="password" type="password" placeholder="e.g. Password@123!" value={password} onChange={(e) => setPassword(e.currentTarget.value)}></input>
            </div>
            <div className="mb-4">
              <div class="login-disclaimer">Forgot password? Please contact your supervisor.</div>
            </div>
            <div className="mb-2">
              <button
                type="button"
                className="btn btn-primary btn-login"
                disabled={isSigningIn}
                onClick={() => loginAndRedirect()}
              >
                {isSigningIn ? 'Signing in…' : 'Sign In'}
              </button>
            </div>
            <div className="login-version-note">{APP_VERSION_NOTE}</div>
          </div>
        
        </div>
      </div>
    </div>
  );
};

export default Login;